import React from 'react'
import { withRouter } from 'react-router-dom'
import cx from 'classnames'
import api from '../../api'
import { Container, Wrapper } from '../../components_renew/Layout'

class MessageItem extends React.PureComponent {
  render () {
    const { data, onClick } = this.props
    return <div className={cx('message-item__container', { 'message-item__container--f': !data['read'] })}
                onClick={onClick}>
      <div className={'message-item__pre'}>{!data['read'] && <i className={'icon-font icon-notification1'}/>}</div>
      <div className={'message-item__content'}>
        <div className={'message-item__title'}>{data['title']}</div>
        <div>{data['createTime']}{process.env['REACT_APP_BUILD_ENV'] === 'development' && ` [${data['type']}]`}</div>
      </div>
    </div>
  }
}

@withRouter
class MessageList extends React.PureComponent {

  state = {
    pageIndex: 1,
    listData: []
  }

  componentDidMount () {
    document.title = '消息列表'
    this.fetchData()
  }

  render () {
    const { listData } = this.state
    return <>
      <Container>
        {/*<Header rightContent={() => <Button onClick={this.readAll}>全部已读</Button>}>消息列表</Header>*/}
        <Wrapper className={'message-list__wrapper'}>
          {listData.map((item, key) => {
            return <MessageItem data={item} key={key} onClick={this.onItemClick.bind(this, item)}/>
          })}
        </Wrapper>
      </Container>
    </>
  }

  fetchData = () => {
    return api.message.fetchMessages()
      .then(res => {
        console.log(res)
        this.setState({ listData: res.list })
      })
  }

  // readAll = () => {
  //   // return api.message.postMessageReadAll()
  // }
  read = (id) => {
    return api.message.postMessageRead(id)
  }

  async onItemClick (itemData) {
    console.log('click')
    const { type, id, url, read } = itemData
    if (!read) await api.message.postMessageRead(id).catch()
    const flag = Boolean([1, 2, 6, 7, 8].find(t => t === type))
    if (flag) {
      this.props.history.push(`${window.PATH.MESSAGE}/${type}/${id}`)
    } else if (url) {
      const token = window.axios.getToken()

      // 处理url
      function handleUrl (url, token) {
        // 原本这块设计好像是为了跳转到活动页，这样写应该还不够
        if (token && url && (typeof url === 'string')) {
          // const reg = /[a-zA-z]+:\/\/\S*/
          // let u = url.match(reg) ? (url) : `http://${url}`
          return (url.indexOf('?') === -1) ? `${url}?token=${token}` : `${url}&token=${token}`
        } else {
          return ''
        }
      }

      // console.log('url', url)
      window.location = handleUrl(url, token)
    } else if (type === 3) {
      const { title, message } = itemData
      localStorage.setItem('title', title)
      localStorage.setItem('message', message)
      this.props.history.push(`${window.PATH.MESSAGE}/text`)
    } else {
      console.log(`type match error. ${type}`)
    }
  }
}

export default MessageList
